export default __webpack_public_path__ + "img/tiny-15.a4a6f6cc.jpg";